import { Component } from '@angular/core';

@Component({
  selector: 'app-main-orden-cambio-fondo-compra',
  template: `<router-outlet></router-outlet>`,
})
export class MainOrdenCambioFondoCompraComponent {
}
